import { useContext, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FiltersContext } from '../../../filters/context';
import { openAddSalesOrderToBatchFromOrdersGrid } from '../../../store/orders/grid/orders.grid.header.actions';
import { useOneOrMoreOrAllOrderSelectedDisabled } from '../disabled-hooks/use-one-or-more-or-all-order-selected-disabled';
import { useContainsDemoOrder } from '../../../demos/hooks/use-contains-demo-order';
import { messages } from './messages';

export const useAddToBatch = () => {
  const dispatch = useDispatch();
  const oneOrMoreOrAllOrderSelectedDisabled = useOneOrMoreOrAllOrderSelectedDisabled();
  const hasDemoOrder = useContainsDemoOrder();
  const shouldBeDisabled = hasDemoOrder || oneOrMoreOrAllOrderSelectedDisabled;
  const disabledReason = hasDemoOrder ? messages.isDemoDisabledMessage : null;
  const { buildApiFilters } = useContext(FiltersContext);
  const apiFilters = buildApiFilters();

  const actionHandler = useCallback(() => {
    dispatch(openAddSalesOrderToBatchFromOrdersGrid(apiFilters));
  }, [apiFilters, dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsAddToBatch,
      isDisabled: shouldBeDisabled,
      disabledReason,
    };
  }, [actionHandler, disabledReason, shouldBeDisabled]);
};
